import { EUserRoles } from '@entities/user/lib/const';
import type { TUser } from '@entities/user/lib/types';
import { ROUTES } from '@shared';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { AppHeader } from '@widgets/app-header/AppHeader';
import { maxHeightFlexSx } from '@shared/ui/commonSx';
import { BaseMainLayout } from '@evrone-erp/uikit';
export interface IAuthorizedLayoutProps {
  children: React.ReactNode;
  user: TUser;
}
export const AuthorizedLayout = ({
  children,
  user
}: IAuthorizedLayoutProps) => {
  const router = useRouter();
  const isAllowed = router.pathname.includes('admin') ? user.role === EUserRoles.superadmin : true;
  useEffect(() => {
    if (user && !isAllowed) {
      router.push(ROUTES.account);
    }
  }, [isAllowed, user, router]);
  if (!isAllowed) {
    return null;
  }
  return <BaseMainLayout sx={maxHeightFlexSx} header={<AppHeader user={user} />}>
      {children}
    </BaseMainLayout>;
};